<template>
  <PassportHero
    variant="asset_group"
    :name="item.name"
    :identifier="item.identifier"
    :readonly="!canUpdate"
    @update="$emit('update', $event)"
  >
    <PassportInsights
      type="tasks"
      :tooltip="$t('tooltips.asset_passport.task_insights')"
      :count="item.open_tasks_count"
      :secondaryCount="item.overdue_tasks_count"
      @click="$emit('goToStep', 'tasks')"
    />
    <PassportInsights
      type="files"
      :count="item.files.length"
      :secondaryCount="item.expired_files_count"
      :class="
        hasPermission(permissions.readDocument, building.id)
          ? 'cursor-pointer'
          : 'pointer-events-none'
      "
      @click="$emit('goToStep', 'files')"
    />
    <PassportInsights
      type="assets"
      :count="item.assets_count"
      class="cursor-pointer"
      @click="$emit('goToStep', 'assets')"
    />
  </PassportHero>
  <div
    class="flex flex-col gap-4"
    :class="{
      'p-4 pb-6': viewport !== 'desktop',
      'p-6 pb-4': viewport === 'desktop',
      'lg:p-6 lg:pb-4': viewport === 'reactive',
    }"
  >
    <PassportNav>
      <PassportNavItem
        variant="asset_group"
        :label="item.group?.name"
        :placeholder="$t('components.passport.parent_group.placeholder')"
        :disabled="!canUpdate"
        @navigate="$emit('goToStep', PropertyType.ASSET_GROUP)"
      />
    </PassportNav>
  </div>
</template>

<script setup>
import { computed, inject } from "vue";
import {
  PassportHero,
  PassportInsights,
  PassportNav,
  PassportNavItem,
} from "@/SharedComponents/Passport";
import { PropertyType } from "@/Composables/useProperties";

defineEmits(["goToStep", "update"]);

const props = defineProps({
  item: { type: Object, required: true },
  building: { type: Object, required: true },
  canUpdate: { type: Boolean, required: false },
  scanned: { type: Boolean, required: false },
  viewport: {
    type: String,
    validator: (val) => ["mobile", "desktop", "reactive"].includes(val),
    default: "reactive",
  },
});

const { hasPermission, permissions } = inject("permissions");

defineExpose({
  editing: computed(() => props.scanned),
});
</script>
